import { render, staticRenderFns } from "./Coach.vue?vue&type=template&id=0acca94a&scoped=true"
import script from "./Coach.vue?vue&type=script&lang=js"
export * from "./Coach.vue?vue&type=script&lang=js"
import style0 from "./Coach.vue?vue&type=style&index=0&id=0acca94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acca94a",
  null
  
)

export default component.exports